var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartHomeBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 7.98428L12.528 4.18195C11.6454 3.49534 10.4094 3.49534 9.52684 4.18195L4.63734 7.98428C4.04188 8.44735 3.69374 9.15954 3.69409 9.91386V16.5139C3.69409 17.5264 4.5149 18.3472 5.52743 18.3472H16.5274C17.5399 18.3472 18.3608 17.5264 18.3608 16.5139V9.91386C18.3608 9.15945 18.0124 8.4472 17.4166 7.98428",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 7.98428L12.528 4.18195C11.6454 3.49534 10.4094 3.49534 9.52684 4.18195L4.63734 7.98428C4.04188 8.44735 3.69374 9.15954 3.69409 9.91386V16.5139C3.69409 17.5264 4.5149 18.3472 5.52743 18.3472H16.5274C17.5399 18.3472 18.3608 17.5264 18.3608 16.5139V9.91386C18.3608 9.15945 18.0124 8.4472 17.4166 7.98428",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 13.7501C12.6408 14.972 9.35725 14.972 7.33325 13.7501",
    stroke: "black",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 13.7501C12.6408 14.972 9.35725 14.972 7.33325 13.7501",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHomeBlack);
export default __webpack_public_path__ + "static/media/smart-home-black.3bd4299627aa03b36aee51308a617ae6.svg";
export { ForwardRef as ReactComponent };